import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import {
	fnCallable,
	GetOutstandingRequisitionsRequest,
	OutstandingRequisitionsResponse,
} from '@fnModels/requisitions';
import LogRocket from 'logrocket';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class RequisitionsFunctions {
	constructor(private fns: AngularFireFunctions) {}

	getOutstandingRequisitions = (
		filterProperty: string,
		filterValue: string,
		businessId: string,
	): Observable<OutstandingRequisitionsResponse[]> => {
		const callable = this.fns.httpsCallable(
			fnCallable.getOutstandingRequisitions,
		);

		const request: GetOutstandingRequisitionsRequest = {
			filterProperty,
			filterValue,
			businessId,
		};

		return callable(request).pipe(
			map((response) => {
				if (response.httpErrorCode) {
					LogRocket.captureMessage(
						'RequisitionFunctions:getOutstandingRequisitions failed',
						{
							extra: response.httpErrorCode,
						},
					);
					return throwError(response);
				} else return response;
			}),
		);
	};
}
